import { useState, useEffect, useContext } from "react";
import { GetDadosPatrimonio, getComponentMap } from "../../General/Format/patrimonio";
import { AnexosContext } from "../../../contexts/anexosProvider";
import { PatrimonioContext } from "../../../contexts/patrimonioProvider";
import { UserContext } from "../../../contexts/userProvider";
import BaseButton from "../../General/FormsComp/Button/BaseButton";
import imprimirEtiqueta from "../imprimirEtiqueta";

const Cadastro = () => {
  const { anexosByClient } = useContext(AnexosContext);
  const { marcasByFornecedor, modelosByMarca, createPatrimonio } = useContext(PatrimonioContext);
  const { user, setAlert } = useContext(UserContext);
  const [editedData, setEditedData] = useState({
    id_usuario: user.id,
    usuario: user?.nome,
  });
  const [anexos, setAnexos] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [modelos, setModelos] = useState([]);

  useEffect(() => {
    let idCliente = editedData?.id_cliente;
    if (idCliente) {
      anexosByClient(idCliente).then((anexos) => {
        setAnexos(anexos);
      });
    }
  }, [editedData?.id_cliente]);

  useEffect(() => {
    let idFornecedor = editedData?.id_fornecedor;
    if (idFornecedor) {
      marcasByFornecedor(idFornecedor).then((marcas) => {
        setMarcas(marcas);
      });
    }
  }, [editedData?.id_fornecedor]);

  useEffect(() => {
    let idMarca = editedData?.id_marca;
    if (idMarca) {
      modelosByMarca(idMarca).then((modelos) => {
        setModelos(modelos);
      });
    }
  }, [editedData?.id_marca]);

  const handleInputChange = (e, index, requiredValue) => {
    if (requiredValue) {
      if (e.target.value == requiredValue) {
        setEditedData({ ...editedData, [e.target.name]: e.target.value });
      } else {
        alert('Selecione o anexo estoque');
        setEditedData({ ...editedData, [e.target.name]: '' });
      }
    } else {
      const { name, value } = e.target;
      setEditedData({ ...editedData, [name]: value });
    }
  };

  const buildNewPatrimonio = () => {
    let newPatrimonio = { ...editedData };
    newPatrimonio.created_at = newPatrimonio.updated_at = new Date().toISOString().slice(0, 19).replace('T', ' ');
    if (!newPatrimonio.id_cliente ||
      !newPatrimonio.id_anexo ||
      !newPatrimonio.id_fornecedor ||
      !newPatrimonio.id_marca ||
      !newPatrimonio.id_modelo ||
      !newPatrimonio.nSerie ||
      !newPatrimonio.nMac ||
      !newPatrimonio.nEtiqueta) {
      setAlert({ visible: true, title: "Atenção!", placeholder: 'Todos os campos são obrigatórios.', confirm: false, type: "warning" });
      return null;
    }
    return newPatrimonio;
  };

  const resetForm = () => {
    setEditedData({
      id_usuario: user.id,
      usuario: user?.nome,
      id_cliente: editedData.id_cliente,
      id_anexo: editedData.id_anexo,
      id_fornecedor: editedData.id_fornecedor,
      id_marca: editedData.id_marca,
      id_modelo: editedData.id_modelo,
    });
  };

  const handleSaveClick = () => {
    const newPatrimonio = buildNewPatrimonio();
    if (!newPatrimonio) return;
    createPatrimonio(newPatrimonio);
    resetForm();
  };

  const handleSaveAndPrintClick = async () => {
    const newPatrimonio = buildNewPatrimonio();
    if (!newPatrimonio) return;
    const etiqueta = {
      local: anexos.find((a) => String(a.id) === String(newPatrimonio.id_anexo))?.nome || '',
      setor: newPatrimonio.nome || '',
      ramal: newPatrimonio.ramal || '',
    };
    const success = await createPatrimonio(newPatrimonio);
    if (success) {
      resetForm();
      imprimirEtiqueta(etiqueta);
    }
  };

  const dados = GetDadosPatrimonio(editedData, anexos, marcas, modelos);
  const componentMap = getComponentMap(handleInputChange, 'modal');

  return (
    <div className="space-y-8">
      <div className="bg-gray-50 dark:bg-gray-700/50 rounded-xl p-6" data-tour-id="cadastro:identificacao">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
          <svg className="w-5 h-5 mr-2 text-vox-blue-600" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
          </svg>
          Identificação do Equipamento
        </h3>
        <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6'>
          {dados.filter(d => ['Cliente','Anexo','Fornecedor','Marca','Modelo'].includes(d.titulo)).map((dado) => (
            <div key={dado.titulo}>
              {componentMap.Cadastro(dado)}
            </div>
          ))}
        </div>
      </div>

      <div className="bg-gray-50 dark:bg-gray-700/50 rounded-xl p-6" data-tour-id="cadastro:usuario">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
          <svg className="w-5 h-5 mr-2 text-vox-green-600" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
          </svg>
          Detalhes do Usuário
        </h3>
        <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6'>
          {dados.filter(d => ['Nome','Setor','Ramal','IP','PassWord'].includes(d.titulo)).map((dado) => (
            <div key={dado.titulo}>
              {componentMap.Cadastro(dado)}
            </div>
          ))}
        </div>
      </div>

      <div className="bg-gray-50 dark:bg-gray-700/50 rounded-xl p-6" data-tour-id="cadastro:tecnica">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
          <svg className="w-5 h-5 mr-2 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" clipRule="evenodd" />
          </svg>
          Identificação Técnica
        </h3>
        <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6'>
          {dados.filter(d => ['Número de Série','MAC','Nº etiqueta patrimonio'].includes(d.titulo)).map((dado) => (
            <div key={dado.titulo}>
              {componentMap.Cadastro(dado)}
            </div>
          ))}
        </div>
      </div>

      <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-3" data-tour-id="cadastro:salvar">
        <BaseButton onClick={handleSaveAndPrintClick} variant="secondary" size="md">
          Salvar e Imprimir
        </BaseButton>
        <BaseButton onClick={handleSaveClick} variant="primary" size="md">
          Salvar
        </BaseButton>
      </div>
    </div>
  );
};

export default Cadastro;
